import { useEffect, useState } from 'react'

import { Flex, TextSpan } from 'app/components/design-system-components'
import SwitchButton from 'app/components/design-system-components/inputs/Switch'
import { ToolTip } from 'app/components/design-system-components/Tooltip'
import { getRenterProfile, updateRenterProfile } from 'app/services/http/users'
import * as snugNotifier from 'app/services/snugNotifier'
import { PROFILE_REMOVAL_POLICY } from 'app/utils/text/helpers'

export function ProfileRetentionToggle() {
  const [retainRenterProfilePref, setRetainRenterProfilePref] = useState(false)
  const [fetching, setFetching] = useState(false)
  const [profileGUID, setProfileGUID] = useState('')

  const switchBtnId = `retain-renter-profile-switch`
  const tooltipId = `retain-renter-profile-tooltip`

  const toggleRetainRentalProfilePref = () => {
    const existingValue = retainRenterProfilePref
    const newValue = !retainRenterProfilePref
    setRetainRenterProfilePref(newValue)

    updateRenterProfile({
      autoRemovalExtended: newValue,
      guid: profileGUID,
    }).catch((err: Error) => {
      const message = err.message || 'Unable to update setting'
      snugNotifier.error(message)
      setRetainRenterProfilePref(existingValue)
    })
  }

  useEffect(() => {
    setFetching(true)
    getRenterProfile()
      .then((response: { autoRemovalExtended?: boolean; guidID: string }) => {
        const { autoRemovalExtended, guidID } = response || {}
        setRetainRenterProfilePref(Boolean(autoRemovalExtended))
        setProfileGUID(guidID)
      })
      .catch((err: Error) => {
        const message = err.message || 'Unable to retrieve setting'
        snugNotifier.error(message)
      })
      .finally(() => {
        setFetching(false)
      })
  }, [])

  return (
    <>
      <Flex alignItems="center">
        <SwitchButton
          onChange={toggleRetainRentalProfilePref}
          value={retainRenterProfilePref}
          buttonID={switchBtnId}
          disabled={fetching}
        />{' '}
        <TextSpan ml={4} mr={2}>
          Retain Renter Profile for 6 months
        </TextSpan>{' '}
        <ToolTip
          toolTipID={tooltipId}
          content={<span>{PROFILE_REMOVAL_POLICY}</span>}
        />
      </Flex>
    </>
  )
}
